module.exports = __webpack_public_path__ + "img/arh_5.a306cb00.jpg";